// AppTheme is used to change and apply the theme to the app wheather it is dark or light theme.
import React from "react";
import { ThemeProvider, StyledEngineProvider, createTheme, responsiveFontSizes, Theme } from "@mui/material";
import { ThemeContext } from "./contexts";
import { Themes } from "./utils";
import { CssBaseline } from "@mui/material";
import { DARK_THEME, DEFAULT_THEME } from './themes';

export const AppTheme: React.FC<{ children: JSX.Element }> = ({ children }) => {
  let [theme, setTheme] = React.useState({
    name: Themes.default,
  });

  const giveMeTheme = () => {
    let currentThemeJson: Theme;

    //Geting the theme json for  the selected theme
    switch (theme.name) {
      case Themes.default:
        currentThemeJson = DEFAULT_THEME as Theme;
        break;

      case Themes.dark:
        currentThemeJson = DARK_THEME as Theme;
        break;

      default:
        currentThemeJson = DEFAULT_THEME as Theme;        
        break;
    }

    //Creating a Theme with json
    let currentTheme = createTheme({ 
      ...currentThemeJson, 
      cssVariables: true,
      components: {
        MuiTextField: {
          styleOverrides: {
            root:{
              input: {
                "&:-webkit-autofill": {
                  WebkitBoxShadow: `0 0 0 ${currentThemeJson.palette.mode === 'light' ? 'white' : 'black'} inset`,
                  WebkitTextFillColor: `${currentThemeJson.palette.mode === 'dark' ? 'white' : 'black'}`,
                },
              },
            },
          }
        }
      }
     });

    //Making theme work with responsive font size
    currentTheme = responsiveFontSizes(currentTheme);

    return currentTheme;
  };

  return (
    <ThemeContext.Provider value={{ ...theme, setTheme }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={giveMeTheme()}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </StyledEngineProvider>
    </ThemeContext.Provider>
  );
};